import { render, staticRenderFns } from "./FormDocumentHistorySummary.vue?vue&type=template&id=877bc558&scoped=true"
import script from "./FormDocumentHistorySummary.vue?vue&type=script&lang=js"
export * from "./FormDocumentHistorySummary.vue?vue&type=script&lang=js"
import style0 from "./FormDocumentHistorySummary.vue?vue&type=style&index=0&id=877bc558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877bc558",
  null
  
)

export default component.exports